import { ItemKind, ItemMappingStatus, ItemStatus, ItemsResponse } from '@frame/lib/hooks/useGetItems'

import { FetchClient } from '../types'
import { APITrueflagResponse, FeatureFlagList, TrueworkJsFeedbackPayload } from './types'

export const commonEndpoints = (fetchClient: FetchClient) => {
  return {
    getFeatureFlags(flags: FeatureFlagList[] = Object.values(FeatureFlagList)) {
      return fetchClient<APITrueflagResponse>('/api/trueflag/experiments/', {
        method: 'POST',
        body: JSON.stringify({ flags }),
      })
    },
    getAddressAutocompletion(input: string) {
      const url = '/api/truework-js/client/address-autocomplete/'
      const searchParams = new URLSearchParams({
        query: input,
      }).toString()
      return fetchClient<{ description: string; place_id?: string }[]>(`${url}?${searchParams}`, { method: 'GET' })
    },
    addFeedback(payload: TrueworkJsFeedbackPayload) {
      const url = '/api/truework-js/feedback/'
      return fetchClient<{ success: boolean }>(url, {
        method: 'POST',
        body: JSON.stringify(payload),
      })
    },
    companySearch(query: string, kinds?: ItemKind[], limit?: number) {
      const params = new URLSearchParams({ limit: limit?.toString() || '10' })
      params.set('q', query)
      if (kinds && kinds?.length > 0) {
        params.set('kind', kinds.join(','))
      }
      params.set('mapping_status', ItemMappingStatus.VERIFIED)
      params.set('status', `${ItemStatus.HEALTHY}, ${ItemStatus.ISSUES}`)
      const url = `/api/truework-js/client/company-search/?${params.toString()}`
      return fetchClient<ItemsResponse>(url, { method: 'GET' })
    },
  }
}
